module.exports = __webpack_public_path__ + "static/media/crise.b7346ee7.jpg";